// LLM generated - Model Claude 4 Sonnet
import { createStyles, Flex, Skeleton, Stack } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  container: {
    width: '100%',
    padding: theme.spacing.md,
    border: `1px solid ${theme.colors.gray[3]}`,
    borderRadius: theme.radius.md,
    backgroundColor: theme.white,
  },
  iconContainer: {
    width: 40,
    height: 32,
    border: `1px solid ${theme.colors.gray[3]}`,
    borderRadius: theme.radius.sm,
    backgroundColor: theme.white,
  },
}));

export function RefundMethodOptionSkeleton() {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <Flex align="center" justify="space-between">
        <Flex align="center" /* eslint-disable-line local-rules/use-theme-tokens */ gap={12}>
          {/* Icon skeleton */}
          <Skeleton className={classes.iconContainer} />

          {/* Text content skeleton */}
          <Stack /* eslint-disable-line local-rules/use-theme-tokens */ spacing={4}>
            {/* Payment method name */}
            <Skeleton height={20} width={120} />
            {/* Amount available text */}
            <Skeleton height={16} width={100} />
          </Stack>
        </Flex>

        {/* Radio button skeleton */}
        <Skeleton height={20} width={20} radius="xl" />
      </Flex>
    </div>
  );
}
